import React, { Fragment } from 'react';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import { API_INSTAGRAM_AUTH, API_CloudBeds } from '../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

class Index extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    var restUrl =
      window.location.href.split('?').length > 1
        ? window.location.href.split('?')[1]
        : window.location.href.split('?')[0];
    var state = restUrl.split('=').length > 1 ? restUrl.split('=')[1] : '';
    if (this.props.instagramId) {
      AxiosAPI({
        method: 'post',
        url: `${API_INSTAGRAM_AUTH}/code/${
          this.props.instagramId
        }?group_id=${getGroupID()}&code=${state}`,
        data: { code: state },
      }).then((res) => {
        localStorage.setItem('ShowInstagramMessage', true);
        window.location.href = `/app/pages/integration/channels`;
      });
    } else {
      window.location.href = `/app/pages/integration/channels`;
    }
  }

  render() {
    return <Fragment></Fragment>;
  }
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, instagramId } = settings;
  return {
    propertyId,
    instagramId,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
